/** Format a raw UZS amount with thousand separators: 386925000 → "386 925 000" */
export function formatMoney(value: number | null | undefined): string {
	return Math.round(value ?? 0).toLocaleString("ru-RU");
}

/** Same as formatMoney, with the currency suffix: 386925000 → "386 925 000 UZS" */
export function formatMoneyUZS(value: number | null | undefined): string {
	return `${formatMoney(value)} UZS`;
}
